export const LoginImages = {
  loginBackground: require('./loginBackground.svg'),
  recoverIcon: require('./recoverIcon.svg'),
  lockIcon: require('./lockIcon.svg'),
  refreshIcon: require('./refresh.svg'),
  loginLeftBackground: require('./background.svg'),
  cyphlensLogo: require('./cyphlensLogo.svg'),
};
